import { ServiceFee } from '@/models/service-fee/service-fee'
import AppId from '@/util/appid'
import { AppSettingService } from '@spa/services/api/appSetting'
import { Either } from 'fp-ts/lib/Either'
import { none, Option, some } from 'fp-ts/lib/Option'

export interface ServiceFeeRepository {
  get: () => Promise<Either<Error, Option<ServiceFee>>>
}

/**
 * @deprecated appsettingから直接取得するのは暫定的な対応であるため、原則として再利用不可
 *
 * サービス手数料（の割合）を取得する利用ケースが継続して存在する場合、
 * その取得方法はサーバー側のみで実装し、クライアントはAPIを経由してサーバーが取得した値を参照すること。
 */
export class AppSettingServiceFeeRepository implements ServiceFeeRepository {
  private appSettingGateway: AppSettingService
  constructor() {
    /**
     * サービス手数料はモールの設定から取得する
     * @see https://github.com/my-color/front/issues/6325#issuecomment-1107965534
     */
    this.appSettingGateway = new AppSettingService(AppId.getHostId())
  }

  async get(): Promise<Either<Error, Option<ServiceFee>>> {
    const result = await this.appSettingGateway.get()

    return result.map<Option<ServiceFee>>(r => (
      r.serviceFeePercent !== null ? some({ percent: r.serviceFeePercent }) : none
    ))
  }
}
